// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

import { ARTICULO_OPERACION_FRAGMENT } from '../../articulo/interfaces/articuloOperacionFragment'

/**
 * Fragmento de campos de articulo
 */

export const GRUPO_FIELDS_FRAGMENT = gql`
  fragment GrupoField on GrupoUnidadMedida {
    _id
    codigoGrupo
    nombreGrupo
    unidadMedidaBase {
      codigoUnidadMedida
      nombreUnidadMedida
    }
    definicion {
      unidadMedida {
        codigoUnidadMedida
        nombreUnidadMedida
      }
      cantidadBase
    }
  }
`
